import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { EdSplitOrientationMixin } from '@/courses/mixins/ed-split-orientation.mixin';
import EdSplitTabs from '@/courses/components/ed-split-tabs/ed-split-tabs.vue';
import { IparamsSplitTabs } from '@/courses/interfaces/params-split-tabs.interface';

@Component({ 
  name: 'ed-split-vertical',
  components: {
    EdSplitTabs
  }
})
export default class EdSplitVertical extends Mixins(EdSplitOrientationMixin) { 

  public orientation: string = 'Vertical';

  get splitTabsParams(): IparamsSplitTabs {
    return {
      contentsId: this.contentsId,
      hasSplits: true,
      oneviewSelected: false,
      tabSelected: this.contentsId.splitVertical
    }
  }
  
}